module.exports = __webpack_public_path__ + "media/images/talent/lp/mv03-9772657db1d5eee1f55d6570234ead40.png";